

















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { VueDropDown } from "@/models/accounting/customerinfo";
import {
  EmailCreateViewModel,
  MessagesViewModel,
} from "@/models/telephony/message";
import {
  Attachment,
} from "@/models/accounting/customerinfo";
import {
  ConversationTypes,
  TemplateAssociationType,
} from "@/enums/enums";
import { Base } from "@/components/common/base";
import {
  templateService,
  jobRequisitionService,
} from "@/shared";
import { IFileUploaderOption } from "@/models/fileUploader";
import { FileUploadDataViewModel } from "@/Alynk.dtos";

@Component({
  props: ["methodName", "progress"],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    isValidate() {
      return this.emailToSend.toEmail && this.emailToSend.body;
    },
  },
  components: {
    Grid: () => import("@/components/common/app.grid.vue"),
    FileUpload: () => import('@/components/common//app.fileupload.v2.vue')
  },
})
 class SendMail extends Base {
  public images = [
    ".ani",
    ".bmp",
    ".cal",
    ".fax",
    ".gif",
    ".img",
    ".jpg",
    ".jpe",
    ".jpeg",
    ".jpg",
    ".mac",
    ".pbm",
    ".pcd",
    ".pcx",
    ".pct",
    ".pgm",
    ".png",
    ".ppm",
    ".psd",
    ".ras",
    ".tga",
    ".tif",
    ".tiff",
    ".wmf",
    "image/ani",
    "image/bmp",
    "image/cal",
    "image/fax",
    "image/gif",
    "image/img",
    "image/jpeg",
    "image/mac",
    "image/pbm",
    "image/pcd",
    "image/pcx",
    "image/png",
    "image/tga",
    "image/tiff",
    "image/wmf",
    "image/ppm",
    "image/ppm",
    "image/psd",
    "image/ras",
  ];
  public allowedFiles = this.images.concat([
    ".pdf",
    ".doc",
    ".docx",
    ".txt",
    ".xls",
    ".xlsx",
  ]);

  public templateloading: boolean = false;
  public bodyloading: boolean = false;
  public customerloading: boolean = false;
  public selectedTemplate: string = "";
  public selectedCustomerNumber: string = "";
  public showAttachmentDialog: boolean = false;
  public files: any = [];
  public selectedFiles: any = [];
  public dragclass: string = "";
  public dragging: boolean = false;
  public disableSubmitButton: boolean = false;
  public fileRef: any;
  public phoneNumber: string = "";
  public constants: any = {
    recordKey: "",
    email: "",
    candidateName: "",
  };
  public uploadBtnLoading: boolean = false;
  public attachmentFiles: FileUploadDataViewModel[] = [];
  public attachments: Attachment[] = [];
  public customerNumberItems: VueDropDown[] = [];
  public templateItems: any[] = [];
  public customerInfo: any;
  public fileUploderRef: string = "requisitionMailRef";

  public actions = [
    {
      type: "button",
      icon: "far fa-folder-open",
      title: this.$parent.$t(
        "sendMessage.rOSendMessageGrid.gridActions.showFolder"
      ) as string,
      disable: (model: MessagesViewModel) => {
        return (
          model.attachments != null &&
          model.attachments &&
          model.attachments.length === 0
        );
      },
      action: (model: MessagesViewModel) => {
        // this.openAttachmentPopup(model);
      },
    },
  ];
  public bodyRules: any = {
    required: (value) =>
      !!value ||
      (this.$parent.$t("sendMessage.validationBodyRequired") as string),
  };

  // tslint:disable-next-line:max-line-length
  public emailToSend: EmailCreateViewModel = new EmailCreateViewModel(
    ConversationTypes[ConversationTypes.Text]
  );

  constructor() {
    super();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit("updateToolBar", buttons);
  }
  public callMethod(methodName): void {
    if (methodName === "backTolist") {
      this.backToList();
    } else if (methodName === "sendMessage") {
      if (!this.emailToSend.toEmail || !this.emailToSend.body) {
        this.showAlert(false, this.$t("sendMessage.validationFormIsInvalid"));
        this.resetMethodName(methodName);
        return;
      }
      this.sendEmail();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== "") {
      this.$emit("resetMethodName", methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: "0",
      type: "button",
      title: this.$t("sendMessage.btnBackToList"),
      disabled: false,
      visible: true,
      class: "btn",
      label: this.$t("sendMessage.btnBackToList"),
      click: "backTolist",
      icon: "fas fa-arrow-left",
    });
    this.$emit("updateToolBar", buttons);
  }
  public mounted() {

    // change code
    this.$root.$emit("sidebar.layout.vue", "requisition");

    this.emailToSend.recordIdentifier = this.$route.params.type;

    // Toolbar
    this.updateToolBar();
    this.$watch("methodtoCall", (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    // SHOULD BIND CUSTOMER KEY, RECORD KEY
    Object.keys(this.constants).forEach((key) => {
      if (this.$route.query[key]) {
        this.constants[key] = (this.$route.query[key] || "").toString().trim();
      }
    });

    this.emailToSend.recordKey = this.constants.recordKey;
    this.emailToSend.toEmail = this.constants.email;
    this.emailToSend.candidateName = this.constants.candidateName;
    this.getTemplates();

    this.customerNumberItems = [
      { name: this.constants.email, value: this.constants.email },
    ];
  }

  public async getTemplates(): Promise<void> {
    try {
      this.templateloading = true;
      const templates = await templateService.getStoreTemplates(TemplateAssociationType.Recruiting);
      this.templateItems = templates.results;
    } catch (e) {
      console.log(e);
    } finally {
      this.templateloading = false;
    }
  }

  public async getTemplateDescription(selectedTemplateId): Promise<void> {
    this.bodyloading = true;
    if (selectedTemplateId == null || selectedTemplateId === "") {
      this.showAlert(false, this.$t("sendMessage.validationInvalidtemplate"));
      return;
    }
    try {
      const template = await templateService.getTemplateDescription(
        selectedTemplateId,
        this.emailToSend.customerName,
        this.emailToSend.vin,
        this.emailToSend.appointmentDateTime,
        this.emailToSend.appointmentNumber,
        "",
        "",
        this.emailToSend.customerKey,
        this.emailToSend.recordKey
      );
      this.emailToSend.body = template.text;
    } finally {
      this.bodyloading = false;
    }
  }

  public openAttachmentDialog(id: string): void {
    this.showAttachmentDialog = true;
  }

  public backToList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({ name: "recruitment.jobrequisition" });
    }
  }

  public removeEmail(email: string, array: string[]): void {
    const index = array.indexOf(email);
    if (index > -1) {
      array.splice(index, 1);
      this.emailToSend.ccEmails = [...array];
    }
  }

  public async sendEmail(): Promise<void> {
    if (this.validateForm()) {
      if (
        this.emailToSend.toEmail == null ||
        this.emailToSend.toEmail === "" ||
        this.emailToSend.subject == null ||
        this.emailToSend.subject === "" ||
        !this.emailToSend.body
      ) {
        this.showAlert(
          false,
          this.$t("Please enter all required fields.")
        );
        return;
      }
      try {
        this.disableSubmitButton = true;
        this.$emit("update:progress", this.disableSubmitButton);
        this.emailToSend.files = this.attachmentFiles;
        await jobRequisitionService.sendEmail(this.emailToSend);
        this.emailToSend.ccEmails = [];
        this.emailToSend.subject = "";
        this.emailToSend.body = "";
        this.showAlert(true, this.$t("Email Sent Successfully"));
        this.emailToSend.files = [];
        this.selectedFiles = [];
        if (this.fileRef && this.fileRef.clear) {
          this.fileRef.clear();
        }
      } finally {
        this.disableSubmitButton = false;
        this.$emit("update:progress", this.disableSubmitButton);
        this.attachmentFiles = [];
        this.files = [];
        this.$root.$emit('resetFileList', this.fileUploderRef);

      }
    }
  }

  public fileDialog: IFileUploaderOption = {
    ref: this.fileUploderRef,
    inputFiles: this.files,
    multiple: true,
    drop: true,
    extensions: this.allowedFiles
  };
  public syncAttachmentFiles(inputFilesToSync: any[], outputFilesToSync: FileUploadDataViewModel[]) {
    this.files = inputFilesToSync;
    this.attachmentFiles = outputFilesToSync;
  }

  public fileUploadLoader(val: boolean) {
    this.uploadBtnLoading = val;
  }
}
export default SendMail;
